import React,{useState,useEffect} from 'react';
import Global_var from '../utils/Global_var';
import { io } from "socket.io-client";
import "./producer.css";
import dayjs from "dayjs";
import JsonStatic from '../utils/static_data_producer.json';
import GET_staticRaces from '../API_MANAGER/GET_staticRaces'
function Producer() {
/*   -------------------- socket state ------------------------  */
  const [socket, setSocket] = useState(); 
  const [response, setResponse] = useState({}); 
/*   -------------------- form state ------------------------  */
  const [roomID, setRoomID] = useState("");
  const [uuid, setUuid] = useState("");
  const [UpdateSessionSelectValue, setUpdateSessionSelectValue] = useState("running");
  const [UpdateCreateSelectValue, setUpdateCreateSelectValue] = useState("race");
/*   -------------------- response state ------------------------  */
  const [SessionData, setSessionData] = useState(''); 
/*   -------------------- laps state ------------------------  */
  const [lapIndex, setLapIndex] = useState(0); 
/*   -------------------- time state ------------------------  */
  const [startTime, setStartTime] = useState(); 
/*   -------------------- other state ------------------------  */
  const [seeRes, setSeeRes] = useState(false); 
  const [seeSocket, setSeeSocket] = useState(false); 
  const [connect, setConnect] = useState(true); 

const SessionDataRow = () => {
  return{
  deviceName: 'gta4lwifi',
  version: '',
  deviceUuid: '5e85f0c1-f394-40b5-ad0a-c97edbf6cee4',
  documentType: 'com.gyfx.LapMonitor.raceJsonData',
  races: [
    {
      name: 'Session',
      extraTime: 60000,
      info: '',
      uuid: '943e9376-9b1f-4f18-ae77-95890516482d',
      date: startTime,
      duration: 300000,
      test: 'azer',
      minLapTime: 2000,
      kind: UpdateCreateSelectValue,
      drivers: [
        {
          kind: 'driver',
          name: 'manuel',
          driverUuid: '645c0b85-cad5-4f69-8162-8484a3a4e9a4',
          transponderId: 20,
          laps: []
        },
        {
          kind: 'driver',
          name: 'sam',
          driverUuid: '645c0b85-cad5-4f69-8162-8484a3a4e9a5',
          transponderId: 19,
          laps: []
        },
        {
          kind: 'driver',
          name: 'marc',
          driverUuid: '645c0b85-cad5-4f69-8162-8484a3a4e9a6',
          transponderId: 22,
          laps: []
        }
      ]
    }
  ]
}
}

  useEffect(() => {
    //setup socket.io
    const s = io(Global_var.live_server);
    setSocket(s);
    console.log(s)
    return () => {
      s.disconnect();
    };
  }, []);
  

  useEffect(() => {
    startTime && socket.emit("createSession", SessionDataRow(), (res) => {
      console.log(res)
      setResponse(res)                   
      res.status == 200 && setSessionData(res.data)
    });
  }, [startTime]);
  

    const createRoom=()=>{
        socket.emit("createRoom", {roomID:roomID,uuid:uuid}, (res) => {

            console.log(res)
            setResponse(res)
           if(res.status == 200){
            setRoomID(res?.data?.roomID)
            setUuid(res?.data?.uuid)
           } 
          });
    }

    const createSession=()=>{
      Chrono()
    }

    const Chrono = () => {
      setStartTime(dayjs())
    }

    const getChronoDifference = () => {
      return dayjs().diff(startTime)
    }
    const UpdateSession=()=>{
        socket.emit("UpdateSession", {state:{status:UpdateSessionSelectValue,date:dayjs()}}, (res) => {
            console.log(res)
            setResponse(res)            
            res.status == 200 && setSessionData(res.data)
          });
    }
    
    const addLaps=(transponderId)=>{
        setLapIndex(lapIndex + 1)
        var lap = {
            transponderId: transponderId,
            endTimestamp: getChronoDifference(),
            lapId: lapIndex,
            duration: 0,
            name: 'name',
            kind: 'normal'
          }
        console.log(lap)
        socket.emit("addLaps", lap, (res) => {
            console.log(res)
            setResponse(res)
          });
    }
    const getJsonStatic = async () => {
      GET_staticRaces.GET_RACE(JsonStatic).then((res) => {
        window.open().document.write(res.data);
        console.log(JsonStatic)
      })
    }
    return (     
      <div className='producer_cont'>
        <h1>Producer</h1>
        <div className='producer_seeResponse_cont'>
        <button className={connect ? 'orangeButton BasicButton':'blueButton BasicButton'} 
              onClick={()=>{setConnect(!connect);connect ? socket.disconnect():setSocket(io(Global_var.live_server))}}>
              {connect ? 'DISCONNECT socket':'CONNECT socket'}
        </button>
        </div>
        <div className='producer_seeResponse_cont'>
          <button className='orangeButton BasicButton' onClick={()=>{setSeeRes(!seeRes)}}>see response {!seeRes?' +':' -'} </button>
          {seeRes &&
          <div className='producer_seeResponse_text'>{JSON.stringify(response)}</div>
          }
        </div>
        <div className='producer_seeResponse_cont'>
          <button className='orangeButton BasicButton' onClick={()=>{setSeeSocket(!seeSocket)}}>see socket {!seeSocket?' +':' -'} </button>
          {seeSocket&&
          <div  className='producer_seeResponse_text'>
            <div>connected: {socket.connected?'true':'false'}</div>
            <div>id: {socket.id}</div>
            {JSON.stringify(socket.io.opts)}
          </div>
          }
        </div>
        <div className='producer_createRoom_cont'>
          <div>
            <p>uuid:</p>
            <input
                  type="text"
                  value={uuid}
                  onChange={(e) => setUuid(e.target.value)}
              />
          </div>
          <div>
            <p>roomID:</p>
            <input
            type="text"
            value={roomID}
            onChange={(e) => setRoomID(e.target.value)}
            />
          </div>
            <button className='orangeButton BasicButton' onClick={()=>{createRoom()}}>createRoom</button>
            {roomID && <button className='blueButton BasicButton' onClick={()=>{window.open(document.location.href.replace('producer','').concat(roomID),'_blank');}}>view room</button>}
        </div> 
        <div className='producer_updateSession_cont'>
          <button className='orangeButton BasicButton' onClick={()=>{createSession()}}>createSession</button>
          <select
              value={UpdateCreateSelectValue}
              onChange={(e) => {
                setUpdateCreateSelectValue(e.target.value);
              }}
            >
            <option value="race">race</option>
            <option value="qualifying">qualifying</option>
            <option value="practice">practice</option>
          </select>
        </div> 
        <div className='producer_updateSession_cont'>
          <button className='orangeButton BasicButton' onClick={()=>{UpdateSession()}}>UpdateSession</button>
          <select
              value={UpdateSessionSelectValue}
              onChange={(e) => {
                setUpdateSessionSelectValue(e.target.value);
              }}
            >
            <option value="paused">paused</option>
            <option value="running">running</option>
            <option value="finished">finished</option>
          </select>
        </div> 
        <div className='producer_addLap_cont'>
            <button className='blueButton BasicButton' onClick={()=>addLaps(20)}>Lap car 20 manuel</button>
            <button className='blueButton BasicButton' onClick={()=>addLaps(19)}>Lap car 19 sam</button>
            <button className='blueButton BasicButton' onClick={()=>addLaps(22)}>Lap car 22 marc</button>
        </div>
        
        <div className='producer_addLap_cont'>         
            <button className='orangeButton BasicButton' onClick={()=>getJsonStatic()}>get Json to Static</button>
        </div>
      </div>    
    );

}

export default Producer;